import { useLazyQuery } from '@apollo/client';
import React, { useState } from 'react';

import {
	LegacyAutocomplete,
	LegacyAutocompleteOptions,
	LegacyAutocompleteInput,
} from '@flixbus/honeycomb-react';

import CrewMemberCredentials from 'common/CrewMemberNameDrivercard';
import { SEARCH_CREW_MEMBER_BY_TEXT } from 'gql';

const CrewMemberAutoComplete = ({ handleSelection = () => {}, label = 'Search crew member' }) => {
	const [options, setOptions] = useState([]);
	const [localValue, setLocalValue] = useState('');

	const [getCrewMembersByText, { loading }] = useLazyQuery(SEARCH_CREW_MEMBER_BY_TEXT, {
		fetchPolicy: 'no-cache',
		notifyOnNetworkStatusChange: true,
		onCompleted: (data) => {
			setOptions(
				data.crewMemberSearch.results.map((driver) => ({
					title: driver.fullName,
					key: driver.id,
					subtitle: driver.driverCard,
					data: driver,
				}))
			);
		},
		onError: () => {
			setOptions([]);
		},
	});

	const onDebounce = (e) => {
		if (!e.target.value) return;
		getCrewMembersByText({ variables: { text: e.target.value } });
	};

	const onSelect = (item) => {
		handleSelection(item.key);
		reset();
	};

	const reset = () => {
		setLocalValue('');
		setOptions('');
	};

	const checkEmpty = (e) => {
		if (e.target.value === '') {
			reset();
		}
	};

	const optionWrapper = (item) => (
		<CrewMemberCredentials name={item.title} number={item.subtitle} />
	);
	return (
		<LegacyAutocomplete
			onDebounce={(e) => onDebounce(e)}
			onSelect={(item) => {
				onSelect(item);
			}}
			onChange={(e) => {
				checkEmpty(e);
				setLocalValue(e.target.value);
			}}
			options={options}
			value={localValue}
			label={label}
		>
			<LegacyAutocompleteInput
				id="autocomplete-crew-member"
				placeholder="Start typing (name or employee number)"
				label={label}
				loading={loading}
				type="search"
			/>
			<LegacyAutocompleteOptions
				label="members"
				optionsToDisplay={5}
				appearance="flat"
				renderOption={(item) => optionWrapper(item)}
			/>
		</LegacyAutocomplete>
	);
};

export default CrewMemberAutoComplete;
